import React from "react";

export function EmptyState({ title = "Nothing here yet", description, action, testid = "phx-empty-state" }) {
  return (
    <div
      data-testid={testid}
      className="border border-dashed border-[var(--phx-slate-300)] bg-white p-12 text-center rounded-[var(--phx-radius-md)]"
    >
      <p className="text-base font-medium text-[var(--phx-slate-700)]">{title}</p>
      {description && <p className="mt-2 text-sm text-[var(--phx-slate-500)]">{description}</p>}
      {action && <div className="mt-5 flex justify-center">{action}</div>}
    </div>
  );
}
